// 19.1.2.5 Object.freeze(O)
var isObject = require('./$.is-object');

require('./$.object-sap')('freeze', function($freeze){
  return function freeze(it){
    return $freeze && isObject(it) ? $freeze(it) : it;
  };
});


//////////////////
// WEBPACK FOOTER
// ./~/babel-core/~/core-js/modules/es6.object.freeze.js
// module id = 129
// module chunks = 0